import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="cta5" aria-labelledby="cta5-heading">
      <div className="cta5-wrap">
        <div className="cta5-main">
          <div className="cta5-copy">
            <p className="cta5-kicker">Strategy first, execution next</p>

            <h2 id="cta5-heading" className="cta5-title">
              Build a focused plan for <span>website growth and lead generation</span>
            </h2>

            <p className="cta5-sub">
              We audit your current funnel, identify priority fixes, and share a
              practical action roadmap you can implement immediately.
            </p>

            <div className="cta5-actions">
              <button
                className="cta5-btn cta5-btnPrimary"
                type="button"
                onClick={() => navigate("/contact")}
              >
                Book free strategy call
              </button>

              <button
                className="cta5-btn cta5-btnOutline"
                type="button"
                onClick={() => navigate("/services")}
              >
                Explore solutions
              </button>
            </div>
          </div>

          <aside className="cta5-side" aria-label="What you get">
            <p className="cta5-sideLabel">What you get</p>
            <p className="cta5-sideSub">A clear diagnostic and implementation path tailored to your goals.</p>

            <div className="cta5-list">
              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Priority opportunities</div>
                  <div className="cta5-liText">Highest-impact actions first</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Funnel map</div>
                  <div className="cta5-liText">Clear page and CTA improvements</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Measurement checklist</div>
                  <div className="cta5-liText">Know what drives leads and revenue</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Banner;
